import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-split-page-wrapper',
  standalone: true,
  imports: [],
  templateUrl: './split-page-wrapper.component.html',
  styleUrl: './split-page-wrapper.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class SplitPageWrapperComponent {

}
